// extracted by mini-css-extract-plugin
module.exports = {"shareWrap":"ShareJob_shareWrap__3wXh5"};